import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";
import { Integration } from "@/models/integration";

class ProjectService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt,
      }
    });
  }

  async getProjects(groups: any): Promise<AxiosResponse<Integration[]>> {
    return await this.client.get("/projects?groups=" + groups)
  }
}

export default ProjectService;
